import { render } from "./SolutionDetailNsddh.vue?vue&type=template&id=64624791"
import script from "./SolutionDetailNsddh.vue?vue&type=script&lang=js"
export * from "./SolutionDetailNsddh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__